import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Header as HeaderComponent } from "@zempler/theme/src/components/header/Header";
import {
  ChildNavItem,
  NavItemProps,
} from "@zempler/theme/src/components/navigation/Navigation";
import { useContext } from "react";
import { PageContext } from "../context/pageContext";

const Header = () => {
  const { hideNavigation, sitewideBanner } = useContext(PageContext)!;

  const data = useStaticQuery(graphql`
    query {
      umbracoSitewideBannerType {
        backgroundColour
        icon
        heading
        description
        bannerId
        enabled
      }
      umbracoHeaderType {
        ctaButton: button {
          ...Link
        }
        navigationItems {
          block {
            components {
              ... on UMBRACO_NavigationItemComponentType {
                link {
                  ...Link
                }
                headerChildItems {
                  link {
                    ...Link
                  }
                  textField
                  navigationChildItems {
                    link {
                      ...Link
                    }
                  }
                }
                ctaButton {
                  ...Link
                }
              }
            }
          }
        }
      }
    }
  `);

  const ctaButton = data.umbracoHeaderType?.ctaButton;

  const navItems =
    data.umbracoHeaderType?.navigationItems[0].block.components.map((item) => {
      const navItem: NavItemProps = {
        link: item.link,
        childItems: item.headerChildItems?.map((child) => {
          const childNavItem: ChildNavItem = {
            link: child.link,
            text: child.textField,
            childItems: child.navigationChildItems?.map(
              (subChild) => subChild.link
            ),
          };
          return childNavItem;
        }),
        ctaButton: item.ctaButton,
      };
      return navItem;
    });

  const globalBannerSettings = data.umbracoSitewideBannerType;
  const pageBannerSettings = sitewideBanner;

  const getBannerSettings = () => {
    if (pageBannerSettings?.enabled) {
      return pageBannerSettings;
    } else if (!pageBannerSettings?.disableSiteWideBanner) {
      return globalBannerSettings;
    }
    return undefined;
  };

  return (
    <HeaderComponent
      navItems={hideNavigation ? [] : navItems}
      ctaButton={hideNavigation ? null : ctaButton}
      bannerSettings={getBannerSettings()}
    />
  );
};

export default Header;
